import { useState } from 'react';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import GoogleDataSyncContactPermissionsWarningDialog from './GoogleDataSyncContactPermissionsWarningDialog';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const GoogleDataSyncContactPermissionsWarningButton = ({
  padding = '400',
  ['data-test-id']: dataTestId = 'google-data-sync-contact-permissions-warning-button',
  children,
  rootNode,
  onAuthenticationSuccess = () => {},
  onAuthenticationError = () => {},
  onClick = () => {}
}) => {
  const [showWarningDialog, setShowWarningDialog] = useState(false);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SelectableButton, {
      "data-test-id": dataTestId,
      padding: padding,
      onClick: event => {
        setShowWarningDialog(true);
        onClick(event);
      },
      selected: false,
      children: children
    }), showWarningDialog && /*#__PURE__*/_jsx(GoogleDataSyncContactPermissionsWarningDialog, {
      rootNode: rootNode,
      onClose: () => setShowWarningDialog(false),
      onAuthenticationSuccess: () => {
        setShowWarningDialog(false);
        onAuthenticationSuccess();
      },
      onAuthenticationError: onAuthenticationError
    })]
  });
};
export default GoogleDataSyncContactPermissionsWarningButton;